const testimonialVideo = () => {
  $(window).scroll(() => {
    const windowHeight = $(window).height();
    const windowWidth = $(window).width();
    const scrollTop = $(document).scrollTop();

    const $videoContainerList = $('.testimonial-video');
    if ($videoContainerList.length === 0) {
      return
    }

    $videoContainerList.each((index, element) => {
      const $elem = jQuery(element);
      const $testimonialContent = $elem.find('.testimonial-content-wrap');
      const $stickyVideo = $elem.find('.sticky-container')
      const elementView = $testimonialContent.offset().top;
      const relativeView = elementView - (windowHeight + scrollTop);
      if (windowWidth > 991) {
        let opacity = 1;
        if (relativeView < 0) {
          opacity = 1 + relativeView * 0.001;
        }
        if (opacity < 0.3) {
          opacity = 0.3;
        }
        $stickyVideo.css('opacity', opacity);
      } else {
        $stickyVideo.css('opacity', 0.5);
      }
    });

  });

};

export default testimonialVideo;
